import { AppInventoryOption } from '@openx/types/targeting/appInventory.ts';
import { ComparisonType } from '@openx/types/targeting/targetingValuesTypes.ts';

export const optionsWithBulkAdd = [AppInventoryOption.APP_BUNDLE_ID, AppInventoryOption.APP_GROUP];

export const comparisonOptions = {
  [AppInventoryOption.APP_BUNDLE_ID]: [ComparisonType.EQUALS, ComparisonType.DOES_NOT_EQUAL],
  [AppInventoryOption.APP_GROUP]: [ComparisonType.EQUALS, ComparisonType.DOES_NOT_EQUAL],
};
